import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'OrganizedUnit/All', method: 'GET', body: null, token: token })
}
